$(document).on('shopify:section:load', function() {

    if ($('.affiliate-program').length) {
        $('.affiliate-program .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberAF() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithDigits(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberAF() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 500);
            }
        
            $this.data('randomNumberAF', randomNumberAF);
            $this.data('animateNumberAF', animateNumberAF);
        
            randomNumberAF();
            animateNumberAF();
        });
    }

    if ($('.earn-commission').length) {
        $('.earn-commission .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }
    
    affiliate_program();
    earn_commission();
});

$(document).ready(function() {

    if ($('.affiliate-program').length) {
        $('.affiliate-program .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberAF() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithDigits(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberAF() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 500);
            }
        
            $this.data('randomNumberAF', randomNumberAF);
            $this.data('animateNumberAF', animateNumberAF);
        
            randomNumberAF();
            animateNumberAF();
        });
    }

    if ($('.earn-commission').length) {
        $('.earn-commission .owl-carousel').each(function() {
            let $carousel = $(this);

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                smartSpeed: 800,
                margin: 20,
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }
    
    affiliate_program();
    earn_commission();
});

$(window).scroll(function() {

    affiliate_program();
    earn_commission();

});

function affiliate_program() {
    if ($('.affiliate-program').length) {
        $('.affiliate-program').each(function() {
            let el = $(this);
        
            if (wSize >= 1280) {
                if (visiblePercent(el) > 90) {
                    el.find('.count span').each(function () {
                        let $this = $(this);
                        if (!$this.data('hasAnimated') && $this.data('randomNumberAF') && $this.data('animateNumberAF')) {
                            $this.data('randomNumberAF')();
                            $this.data('animateNumberAF')();
                            $this.data('hasAnimated', true);
                        }
                    });
                }
            }
            else {
                if (visiblePercent(el) > 30) {
                    el.find('.count span').each(function () {
                        let $this = $(this);
                        if (!$this.data('hasAnimated') && $this.data('randomNumberAF') && $this.data('animateNumberAF')) {
                            $this.data('randomNumberAF')();
                            $this.data('animateNumberAF')();
                            $this.data('hasAnimated', true);
                        }
                    });
                }
            }
        });    
    }
}

function earn_commission() {
    if ($('.earn-commission').length) {
        $('.earn-commission').each(function() {
            if (wSize >= 1280) {
                let el = $(this);
        
                if (visiblePercent(el) > 50) {
                    el.find('.col-custom:nth-child(1)').css({
                        'top': '0',
                        'opacity': '1'
                    });
                    setTimeout(() => {
                        el.find('.col-custom:nth-child(2)').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 120);
                    setTimeout(() => {
                        el.find('.col-custom:nth-child(3)').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 140);
                    setTimeout(() => {
                        el.find('.col-custom:nth-child(4)').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 160);
                    setTimeout(() => {
                        el.find('.col-custom:nth-child(5)').css({
                            'top': '0',
                            'opacity': '1'
                        });
                    }, 180);
                }
            }
        });    
    }
}